var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Actia"}},[_c('SovecoNavBar'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box has-text-centered"},[_c('div',{staticClass:"box has-text-centered"},[_c('a',{attrs:{"href":"https://sovecotech.com/apk/sovecotech33.apk"}},[_vm._v("Scarica l'app Android")])])])
}]

export { render, staticRenderFns }